/**
 * Service: posConfigSettings
 */
angular.module('acme.common.service.posConfigSettings', [])
.service('PosConfigSettingsService', [function() {

  return {

    model: {
      enableCustomerInputOnPurchase: false
    },

    init: function() {
      return true;
    },

    setModel: function(model) {
      this.model = (model) ? model : { enableCustomerInputOnPurchase: false };
    },

    getModel: function() {
      return this.model;
    }

  };


}]);